import React from 'react';
import './Email.sass';

export default function Email() {
	return (
		<svg
			width="20px"
			height="12px"
			viewBox="0 0 20 12"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<path
					d="M10,6.642 L0.814,1 L19.185,1 L10,6.642 Z M19,10.896 L1,10.896 L1,2.288 L9.477,7.494 L10,7.816 L10.523,7.494 L19,2.288 L19,10.896 Z M0,11.896 L20,11.896 L20,7.10542736e-15 L0,7.10542736e-15 L0,11.896 Z"
					fill="#E31837"
				/>
			</g>
		</svg>
	);
}
